<template>
  <ModuleWrapper
    :moduleId="moduleId"
    title="Landing Agenda Background"
    class="tw-relative"
    @initializeData="initializeData"
  >
    <template #main>
      <ConditionalColorPicker
        id="bg-color-picker"
        label="Background Color"
        type="color"
        :initialColor="agendaBackgroundColor.style"
        @colorChange="onBackgroundColorChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ConditionalColorPicker from '../components/ConditionalColorPicker.vue';
import { color } from '../data/defaultValues';

import { getRGBAstring, destructureRgbColor } from '@/utils/utils.js';

export default {
  name: 'AgendaBackground',
  components: {
    ModuleWrapper,
    ConditionalColorPicker
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      agendaBackgroundColor: color
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInThemeObj: 'setChangesMadeInThemeObj'
    }),
    initializeData() {
      const moduleKeys = ['splash_background_color'];
      const { splash_background_color: agendaBackgroundColor } = this.getInitialModuleData(moduleKeys);
      if (agendaBackgroundColor) {
        this.agendaBackgroundColor = destructureRgbColor(agendaBackgroundColor || agendaBackgroundColor.style);
      }
    },
    onBackgroundColorChange(selectedColor) {
      if (selectedColor.alpha > 1) {
        selectedColor.alpha = 1;
        selectedColor.style = getRGBAstring(selectedColor);
      }

      this.agendaBackgroundColor = selectedColor;
      this.setChangesMadeInThemeObj({
        splash_background_color: selectedColor.style
      });
    }
  }
};
</script>
